import { useCallback } from "react";

import { NOTIFICATIONS } from "~/constans/notifications";
import { STATUS_TYPES } from "~/constans/statuses";
import { useAddNotificationMutation } from "~/schemas/generated/graphql";

export const useNotify = () => {
  const [addNotificationMutation] = useAddNotificationMutation({});

  const notifySuccess = useCallback(
    (content: string) =>
      addNotificationMutation({
        variables: { type: NOTIFICATIONS.success, content },
      }),
    [addNotificationMutation],
  );

  const notifyError = useCallback(
    (content: string) =>
      addNotificationMutation({
        variables: { type: NOTIFICATIONS.error, content },
      }),
    [addNotificationMutation],
  );

  const notifyWarning = useCallback(
    (content: string) =>
      addNotificationMutation({
        variables: { type: NOTIFICATIONS.warning, content },
      }),
    [addNotificationMutation],
  );

  const notifyReport = useCallback(
    (id: string) =>
      addNotificationMutation({
        variables: {
          status: STATUS_TYPES.FORMATION,
          type: NOTIFICATIONS.report,
          id,
        },
      }),
    [addNotificationMutation],
  );

  return { notifySuccess, notifyError, notifyWarning, notifyReport };
};
